Ext.define('PanelHereMapkaWithMarker', {
    extend: 'Ext.container.Container',
    alias: 'widget.panelheremapkawithmarker',
    height: 400,
    layout: {
        type: 'vbox',
        align: 'stretch'
    },
    scrollable: true,
    paramsPoint: null,
    initComponent: function () {
        this.items = [{
            xtype: 'panel',
            layout: 'fit',
            flex: 1,
            items: [{
                xtype: 'box',
                itemId: 'mapContainer',
                autoEl: {
                    tag: 'div'
                }
            }]
        }];
        this.callParent(arguments);
        this.on('afterrender', this.onRenderEvent, this);
    },
    onRenderEvent: function () {
        this.renderedV = true;
        if (this.paramsPoint) {
            this.initializeMap();
        }
    },
    showMap: function (params) {
        this.paramsPoint = params;
        if (this.renderedV) {
            this.initializeMap();
        }
    },
    initializeMap: function () {
        loadHereMapLoader(() => {
            var mapContainer = this.down('#mapContainer');
            var mapContainerDom = mapContainer.el.dom;
            var point = {lat: this.paramsPoint[0], lng: this.paramsPoint[1]};
            var myOptions = {
                zoom: 8,
                center: point
            };
            var defaultLayers = AppMapPlatform.createDefaultLayers();
            this.map = new H.Map(mapContainerDom, defaultLayers.vector.normal.map, myOptions);
            var mapEvents = new H.mapevents.MapEvents(this.map);
            var behavior = new H.mapevents.Behavior(mapEvents);
            this.mapUi = H.ui.UI.createDefault(this.map, defaultLayers);
            this.mapUi.getControl('mapsettings').setDisabled(true);
            this.mapUi.getControl('mapsettings').setVisibility(false);
            this.mapUi.getControl('zoom').setAlignment('top-left');
            this.mapUi.getControl('scalebar').setVisibility(false);
            this.mapUi.getControl('scalebar').setDisabled(true);
            var marker = this.createMarker(point, 'Marker');
            this.map.addObject(marker);
            Ext.defer(() => {
                this.map.getViewPort().resize();
            }, 500, this);
        }, this);
    },
    createMarker: function (latLng, title) {
        var marker = new H.map.Marker(latLng);
        marker.setData({
            pos: latLng,
            title: title
        });
        return marker;
    }
});